export default __webpack_public_path__ + "55858e0fc3972d13413f778c465a9cae.png";